import { AnalyticsType } from '@interfaces/analytics';

export enum QuestionType {
  RATE = 'RATE',
  TEXTAREA = 'TEXTAREA',
  SELECT = 'SELECT',
  HAPPINESS = 'HAPPINESS',
}

export interface SelectOption {
  id: string;
  text: string;
}

export interface BaseQuestion {
  id: string;
  type: QuestionType;
  title: string;
  subtitle?: string;
  required?: boolean;
  analyticsKey?: AnalyticsType;
}

export interface RateQuestion extends BaseQuestion {
  type: QuestionType.RATE;
  minValue: number;
  maxValue: number;
}

export interface HappinessQuestion extends BaseQuestion {
  type: QuestionType.HAPPINESS;
}

export interface SelectQuestion extends BaseQuestion {
  type: QuestionType.SELECT;
  options: SelectOption[];
  multiselect: boolean;
}

export interface TextareaQuestion extends BaseQuestion {
  type: QuestionType.TEXTAREA;
  placeholder?: string;
  maxLength?: number;
}

export type Question =
  | RateQuestion
  | HappinessQuestion
  | SelectQuestion
  | TextareaQuestion;

export interface FeedbackFormData {
  id: string;
  formTitle: string;
  steps: Question[];
}

export interface FeedbackFormState {
  data: FeedbackFormData;
  currentStep: number;
  answers: Record<string, any>;
}

export interface FeedbackFormProps {
  data: FeedbackFormData;
  onStepChange: (step: number) => void;
  onAnswerChange: (questionId: string, value: any) => void;
  onSubmit: (answers: Record<string, any>) => void;
  onClose: () => void;
}
